import type { TemplateFile } from '../types';

export const getFileUrl = (file: TemplateFile, baseUrl: string) => {
  return file.url || baseUrl + '/' + file.filename;
};
